import { createReducer, createAction } from '@reduxjs/toolkit';
import type { RootState } from '@store/types';
import type { DynamicConfigState } from './types';

// Re-export types for consumers
export type { DynamicConfigState } from './types';

const initState: DynamicConfigState = {
  machineDetailsLevel: false,
};

export const setMachineDetailsLevel = createAction<string | false>('dynamicConfig/setMachineDetailsLevel');

export const clear = createAction('clear');

// === Selectors ===

export const selectMachineDetailsLevel = (state: RootState) => state.dynamicConfig.machineDetailsLevel;

export default createReducer<DynamicConfigState>(initState, {
  [setMachineDetailsLevel.type]: (state, action) => ({
    ...state,
    machineDetailsLevel: action.payload,
  }),
  [clear.type]: () => {
    return initState;
  },
});
